import { ChevronRightIcon, ExternalLinkIcon } from './ds/icons';
import Eyebrow from './ds/Eyebrow';

// `short` and `blurb` are the same guide said in fewer words, for the footer
// an app's Overview ends on: four columns of a title and one line, where the
// cards' longer names wrap.
const GUIDES = [
  {
    label: 'Get started',
    desc: 'Deploy your first web app in five minutes.',
    short: 'Get started',
    blurb: 'Deploy a first app in minutes.',
    href: 'https://www.back4app.com/docs-containers',
  },
  {
    label: 'Creating a new web application',
    desc: 'Repository, build command, and env vars.',
    short: 'Create a web app',
    blurb: 'From a repository or a Docker image.',
    href: 'https://www.back4app.com/docs-containers/integrate-with-github',
  },
  {
    label: 'Manage your web application',
    desc: 'Redeploy, restart, scale, and domains.',
    short: 'Manage your app',
    blurb: 'Domains, variables, plans and logs.',
    href: 'https://www.back4app.com/docs-containers/deployment-process',
  },
  {
    label: 'Troubleshooting',
    desc: 'Read build logs and fix failed deploys.',
    short: 'Troubleshooting',
    blurb: 'Fix failed builds and health checks.',
    href: 'https://www.back4app.com/docs-containers/troubleshooting',
  },
];

const Guides = ({ plain = false }: {
  /** A title and one line to a column, on the page rather than in cards: for
   *  a screen where the guides close the page instead of filling it, as under
   *  an app's Overview. */
  plain?: boolean,
}) => (
  <div className={`flex flex-col gap-3 ${plain ? 'lg:gap-6' : ''}`}>
    <Eyebrow>guides &amp; docs</Eyebrow>

    {/* Cards on desktop, where there is room for the one-liner; a plain list
        with a chevron on mobile, where there is not. */}
    {plain ? (
      <div className="hidden lg:grid grid-cols-2 xl:grid-cols-4 gap-x-8 gap-y-6">
        {GUIDES.map(guide => (
          <a
            key={guide.href}
            href={guide.href}
            target="_blank"
            rel="noreferrer"
            className="b4-focus group min-w-0 flex flex-col gap-2 rounded-control"
          >
            <span className="flex items-center gap-2 text-ds-15 font-semibold text-white">
              <span className="min-w-0 truncate group-hover:underline underline-offset-4">{guide.short}</span>
              <ExternalLinkIcon size={14} className="text-navy-300 group-hover:text-white transition-colors duration-[120ms]" />
            </span>
            <span className="text-ds-135 leading-[1.5] text-navy-200">{guide.blurb}</span>
          </a>
        ))}
      </div>
    ) : (
      <div className="hidden lg:grid grid-cols-4 gap-3">
        {GUIDES.map(guide => (
          <a
            key={guide.href}
            href={guide.href}
            target="_blank"
            rel="noreferrer"
            className="b4-focus flex flex-col gap-1.5 p-4 rounded-card bg-navy-700 hover:bg-navy-600 transition-colors duration-[120ms]"
          >
            <span className="text-ds-135 font-medium text-white leading-[1.4]">{guide.label}</span>
            <span className="text-ds-125 text-navy-200 leading-[1.45]">{guide.desc}</span>
          </a>
        ))}
      </div>
    )}

    <div className="lg:hidden rounded-card border border-navy-500 bg-navy-700 overflow-hidden flex flex-col">
      {GUIDES.map((guide, i) => (
        <a
          key={guide.href}
          href={guide.href}
          target="_blank"
          rel="noreferrer"
          className={`b4-focus flex items-center justify-between gap-2.5 min-h-[48px] px-4 text-ds-135 font-medium text-navy-100 ${i ? 'border-t border-navy-500' : ''}`}
        >
          <span>{guide.label}</span>
          <ChevronRightIcon size={14} className="text-navy-300" />
        </a>
      ))}
    </div>
  </div>
);

export default Guides;
